import { render, staticRenderFns } from "./planoConta.vue?vue&type=template&id=d9468826"
import script from "./planoConta.vue?vue&type=script&lang=js"
export * from "./planoConta.vue?vue&type=script&lang=js"
import style0 from "./planoConta.vue?vue&type=style&index=0&id=d9468826&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports